import { SystemSettingsView } from '../components/SystemSettingsView';

export default function SettingsPage() {
  return <SystemSettingsView />;
}
